var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStore3Fill = function SvgStore3Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.6 12.9v6.3a.9.9 0 0 1-.9.9H5.3a.9.9 0 0 1-.9-.9v-6.3h-.9v-1.8l.9-4.5h16.2l.9 4.5v1.8zm-14.4 0v5.4h12.6v-5.4zm.9.9h7.2v2.7H7.1zM4.4 3.9h16.2v1.8H4.4z"
  })));
};
export default SvgStore3Fill;